import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import router from './router'
import http from './http'
import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

Vue.config.productionTip = false

Vue.prototype.$http = http

Vue.mixin({
  data() {
    return {
      msg: 'hello',
      baseURL: '/server/web/api',                           // 后端，和前端部署到同一服务器，反向代理到/server/，不再依赖域名，原来通过域名访问是http://stock-dashboard-server.ddindex.com/web/api
      // baseURL: 'http://127.0.0.1:7001/web/api',
      baseAKToolsURL: '/aktools/api/public',                // aktools，和前端部署到同一服务器，反向代理到/aktools/，不再依赖域名，原来通过域名访问是http://stock-dashboard-aktools.ddindex.com/api/public
      platesByAnyStock: 'https://flash-api.xuangubao.cn/api/stage2/plates_by_any_stock?symbol=600001.SS&fields=core_avg_pcp,plate_name',
    }
  },
  methods: {
    mixinMethod() {
      console.log(this.msg + '，这是mixin混入的方法')
    }
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
